import type { LocationsResponse, MapResponse, MetaResponse, ObservationResponse, ProbesResponse, Provider, RegionProvider, Submission } from '@latency-globe/shared';

export class ApiError extends Error {
  constructor(public status: number, public code: string, detail: string) { super(detail); }
}

async function call<T>(url: string, init?: RequestInit): Promise<T> {
  const res = await fetch(url, init);
  if (!res.ok) {
    let code = 'http_error', detail = res.statusText;
    try { const b = (await res.json()) as { error?: string; detail?: string }; code = b.error ?? code; detail = b.detail ?? detail; } catch { /* not JSON */ }
    throw new ApiError(res.status, code, detail);
  }
  return (await res.json()) as T;
}

export const getMeta = () => call<MetaResponse>('/api/meta');

/** `b=<build>` makes the URL self-invalidating so the edge can cache it for a day. */
export const getMap = (provider: Provider, precision: number, prefix: string, build: number) =>
  call<MapResponse>(`/api/map/${provider}?precision=${precision}${prefix ? `&prefix=${prefix}` : ''}&b=${build}`);

export const getLocations = (provider: Provider, build: number) => call<LocationsResponse>(`/api/locations/${provider}?b=${build}`);

export const getProbes = (provider: RegionProvider, cell: string) => call<ProbesResponse>(`/api/probes/${provider}?cell=${cell}`);

export const postObservation = (body: Submission) =>
  call<ObservationResponse>('/api/observation', { method: 'POST', headers: { 'content-type': 'application/json' }, body: JSON.stringify(body) });
